import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService } from 'app/services';
import { CookieService } from 'ngx-cookie';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmDismissDialogComponent } from '../shared/components';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  /**
   * @todo create a generic http service which is responsible for all
   * header fetching etc
   */
  constructor(private http: HttpClient, private cookieService: CookieService, private helperService: HelperService, private router: Router, private dialogService: DialogService) { }

  private getHeaders() {
    const token: string = <string>(<unknown>this.cookieService.getObject('alpat'));
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: token || null,
    });
    return headers;
  }

  /**
   * ==============================
   *          Helper Methods
   *  ==============================
   */

  private successHandler(res) {
    const d = res;
    try {
      if (d.status) {
        return Promise.resolve(d.response);
      }
    } catch (err) {
      console.error('Success Handler catch', err);
    }
  }

  private errorHandler(result: any) {
    try {
      if (!result.error.status) {
        if (result.status === 440 || result.status === 401) {
          this.helperService.logout();
        }

        return Promise.reject(result.error.error);
      }
    } catch (err) {
      console.error('Error Handler catch', err);
    }
  }

  closeConversation(data): Promise<any> {
    return new Promise((resolve, reject) => {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '35%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          title: 'Mark conversation as Close?',
          message: ' Are you sure you want to Mark this conversation as Close?',
          button: {
            success: { title: 'Close' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe((close: any) => {
        onClose.unsubscribe();

        if (!close.isSuccess) return reject(new Error('Operation canceled'));

        const promise = this.http
          .post(`${environment.api_base_url}/chat/conversation/closeContact`, this.helperService.encryptData(data), { headers: this.getHeaders() })
          .toPromise()
          .then(this.successHandler.bind(this))
          .catch(this.errorHandler.bind(this));

        promise.then((data) => resolve(data)).catch((error) => reject(error));
      });
    });
  }

  openConversation(data): Promise<any> {
    return new Promise((resolve, reject) => {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '35%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          title: 'Mark conversation as Open?',
          message: ' Are you sure you want to Mark this conversation as Open?',
          button: {
            success: { title: 'Open' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe((close: any) => {
        onClose.unsubscribe();

        if (!close.isSuccess) return reject(new Error('Operation canceled'));

        const promise = this.http
          .post(`${environment.api_base_url}/chat/conversation/openContact`, this.helperService.encryptData(data), { headers: this.getHeaders() })
          .toPromise()
          .then(this.successHandler.bind(this))
          .catch(this.errorHandler.bind(this));

        promise.then((data) => resolve(data)).catch((error) => reject(error));
      });
    });
  }

  getConversations(query): Promise<any> {
    const url = this.helperService.constructQueryParams(`${environment.api_base_url}/chat/conversation`, query);
    return this.http.get(url, { headers: this.getHeaders() }).toPromise().then(this.successHandler.bind(this)).catch(this.errorHandler.bind(this));
  }

  getCustomerContacts(query): Promise<any> {
    const url = this.helperService.constructQueryParams(`${environment.api_base_url}/chat/contacts`, query);
    return this.http.get(url, { headers: this.getHeaders() }).toPromise().then(this.successHandler.bind(this)).catch(this.errorHandler.bind(this));
  }

  getMessages(query): Promise<any> {
    const url = this.helperService.constructQueryParams(`${environment.api_base_url}/chat/messages`, query);
    return this.http.get(url, { headers: this.getHeaders() }).toPromise().then(this.successHandler.bind(this)).catch(this.errorHandler.bind(this));
  }

  resendMessage(messageId: string): Promise<any> {
    return this.http
      .get(`${environment.api_base_url}/chat/sms/resend/${messageId}`, {
        headers: this.getHeaders(),
      })
      .toPromise()
      .then(this.successHandler.bind(this))
      .catch(this.errorHandler.bind(this));
  }

  sendMessage(contactId, data): Promise<any> {
    return this.http
      .post(`${environment.api_base_url}/chat/sms/${contactId}`, this.helperService.encryptData(data), { headers: this.getHeaders() })
      .toPromise()
      .then(this.successHandler.bind(this))
      .catch(this.errorHandler.bind(this));
  }

  getContacts(query): Promise<any> {
    let apiUrl = `${environment.api_base_url}/contacts`
    if(query?.customerId) {
      apiUrl +=`/${query?.customerId}`;
    }
    const url = this.helperService.constructQueryParams(apiUrl, query);
    return this.http.get(url, { headers: this.getHeaders() }).toPromise().then(this.successHandler.bind(this)).catch(this.errorHandler.bind(this));
  }

  getOpenChatCount(): Promise<any> {
    return this.http
      .get(`${environment.api_base_url}/chat/conversation/openCount`, {
        headers: this.getHeaders(),
      })
      .toPromise()
      .then(this.successHandler.bind(this))
      .catch(this.errorHandler.bind(this));
  }
}
